import { useEffect, useState } from "react";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import {
  Autocomplete,
  Box,
  Chip,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  NOTIFICATION_MESSAGE,
  PAGINATION_LIMIT,
  TASK_TYPES,
  USER_ROLE,
} from "../../../utils/constant";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllV2DasboardTasks,
  getTaskSubTask,
} from "../../../thunks/dashboard";
import PaginationComponent from "../../../components/PaginationComponent";
import moment from "moment";
import Loader from "../../../components/Loader";
import { getAllUser, getConsultant } from "../../../thunks/user";
import { completeV2Task } from "../../../thunks/task";
import { showSnackbar } from "../../../slice/snackbarSlice";
import {
  allocateOrCompleteIndividualTask,
  allocateOrCompleteTask,
  getInstructionType,
} from "../../../thunks/instruction";
import { allocateOrCompleteClientTask } from "../../../thunks/client";
import { updateMainTask, updateSubTask } from "../../../slice/dashboard";
import { setTaskData } from "../../../slice/task";
import { useNavigate } from "react-router-dom";
import AlertComponent from "../../../components/alert";
import TaskCardDashboard from "./TaskCardDashboard";
import { getMilestoneV2 } from "../../../thunks/lookup";

const NewThingsToDo = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state?.auth?.currentUser);
  const subTasksMap = useSelector((state) => state?.dashboard?.subTasks);
  const allTasks = useSelector((state) => state?.dashboard?.allMainTasks);
  const lookups = useSelector((state) => state?.lookupData);
  let { Role: roles } = lookups || {};
  const [expandedTask, setExpandedTask] = useState(null);
  const [loader, setLoader] = useState(false);
  const [isCompleteTask, setCompleteTask] = useState(false);
  const [selectedCompleteTask, setselectedCompleteTask] = useState(null);
  const [totalCount, setTotalCount] = useState(1);
  const [consultants, setConsultants] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [milestoneList, setMilestoneList] = useState([]);
  const [filterPayload, setFilterPayload] = useState({
    page: 1,
    limit: PAGINATION_LIMIT,
    taskType: userDetails?.role === USER_ROLE?.CONSULTANT ? "All" : "All",
    userId: null,
    roleToSearch: [],
    instructionTypeId: [1],
  });

  const instructionTypes = useSelector(
    (state) => state?.instruction?.instructionTypeData
  );

  //function to compete task
  const handleCompleteTask = (task, parentTask, payload, e) => {
    e.stopPropagation();
    setCompleteTask(true);
    setselectedCompleteTask({ task, parentTask, payload });
  };

  // function to open subTask
  const handleSubTaskOpen = async (task, e, forceFetch = false) => {
    e?.stopPropagation?.();

    const isAlreadyExpanded = expandedTask === task.id;

    if (!forceFetch) {
      setExpandedTask(isAlreadyExpanded ? null : task.id);
    }

    //  Fetch only if forced or data is not in cache
    const alreadyFetched = subTasksMap?.[task.id];
    if (forceFetch || !alreadyFetched) {
      try {
        setLoader(true);
        await dispatch(getTaskSubTask(task?.id)).unwrap();
        setLoader(false);
      } catch (error) {
        setLoader(false);
        dispatch(
          showSnackbar({
            show: true,
            message: error?.message,
            severity: "error",
          })
        );
      }
    }
  };

  //function to handle redirection from dashboard's tasks
  const handleRedirect = (task) => {
    const {
      instructionId,
      taskType,
      id: taskId,
      instructionProductId,
      apiVersionId,
      isSubTask,
      instruction,
    } = task;

    const leadClientId =
      instruction?.InstructionLeadClient?.[0]?.LeadClient?.leadClientId || null;

    if (taskType === "Client") {
      dispatch(setTaskData({ taskType, leadClientId, taskId, apiVersionId }));
      navigate(`/app/client/update-client/${leadClientId}`, {
        state: { fromDashboard: true },
      });
    } else {
      if (taskType && ["Custom", "Instance"].includes(taskType)) {
        dispatch(
          setTaskData({ taskType, instructionId, taskId, apiVersionId })
        );
      } else {
        dispatch(
          setTaskData({
            instructionId,
            taskId,
            instructionProductId,
            apiVersionId,
            isSubTask,
          })
        );
      }
      navigate(`/app/instructions/dashboard/${instructionId}`, {
        state: { fromDashboard: true },
      });
    }
  };

  //function to handle redirection from dashboard's subTasks
  const handleRedirectSubTask = (subTask, parentTask) => {
    const {
      instructionId,
      taskType,
      id: taskId,
      instructionProductId,
      apiVersionId,
      isSubTask,
      instruction,
    } = subTask;

    if (apiVersionId === null && taskType === "Instruction2" && isSubTask) {
      dispatch(
        setTaskData({
          instructionId,
          taskId,
          instructionProductId,
          apiVersionId,
          isSubTask,
        })
      );
    }
    navigate(`/app/instructions/dashboard/${instructionId}`, {
      state: { fromDashboard: true },
    });
  };

  // function to change task type
  const handleChangeTaskType = (value) => {
    const updatedPayload = { ...filterPayload, taskType: value, page: 1 };
    setFilterPayload(updatedPayload);
    getAllTasks(updatedPayload);
  };

  // function to change meeting type
  const handleChangeMeetingType = (value) => {
    let instructionTypeIdArray;

    if (value === "null") {
      // "Both" selected: send all type IDs
      instructionTypeIdArray = instructionTypes?.map((type) => type?.id);
    } else {
      // Send selected ID in an array
      instructionTypeIdArray = [value];
    }

    const updatedPayload = {
      ...filterPayload,
      instructionTypeId: instructionTypeIdArray,
      page: 1,
    };

    setFilterPayload(updatedPayload);
    getAllTasks(updatedPayload);
  };

  // Method to handle change role
  const handleChangeRole = (value) => {
    setFilterPayload({
      ...filterPayload,
      page: 1,
      roleToSearch: value !== null ? [value] : [],
    });
    const payload = {
      ...filterPayload,
      roleToSearch: value !== null ? [value] : [],
      page: 1,
    };

    getAllTasks(payload);
  };

  // function to change page
  const handleChangePage = (event, value) => {
    const updatedPayload = { ...filterPayload, page: value };
    setFilterPayload(updatedPayload);
    getAllTasks(updatedPayload);
  };

  // Method to handle change user
  const handleChangeConsultant = (value) => {
    setFilterPayload({ ...filterPayload, page: 1, userId: value });
    const payload = {
      ...filterPayload,
      userId: value,
      page: 1,
    };
    getAllTasks(payload);
  };

  const checkDate = (data) => {
    // Parse the provided date into a Moment.js object
    const tempCurrentDate = moment().format("DD/MM/YYYY hh:mm A");
    const tempProvidedDate = moment(data?.dueDate || null).format(
      "DD/MM/YYYY hh:mm A"
    );
    const tempEndDate = moment(data?.endDate || null).format(
      "DD/MM/YYYY hh:mm A"
    );
    const providedDate = moment(tempProvidedDate, "DD/MM/YYYY hh:mm A");
    const currentDate = moment(tempCurrentDate, "DD/MM/YYYY hh:mm A");
    const endDate = moment(tempEndDate, "DD/MM/YYYY hh:mm A");
    // Compare the dates
    const isDateBeforeComplete = providedDate.isBefore(currentDate);
    const isDateAfterComplete = providedDate.isBefore(endDate);
    if (isDateBeforeComplete && !data?.isCompleted) {
      return true;
    } else if (isDateAfterComplete && data?.isCompleted) {
      return true;
    } else {
      return false;
    }
  };

  function getInitialsFromFullName(name) {
    if (!name) return "";

    const words = name.trim().split(" ");
    if (words.length === 0) return "";

    const firstLetter = words[0]?.charAt(0) || "";
    const lastLetter = words[words.length - 1]?.charAt(0) || "";

    return (firstLetter + lastLetter).toUpperCase();
  }

  // get instructionTypes
  const getInstructionTypeData = async () => {
    try {
      setLoader(true);
      await dispatch(getInstructionType()).unwrap();
      setLoader(false);
    } catch (error) {
      setLoader(false);
      dispatch(
        showSnackbar({
          show: true,
          message: error?.message,
          severity: "error",
        })
      );
    }
  };

  //function to get all milestones to show color of tasks/subTasks
  const handleGetMilestones = async () => {
    try {
      const params = {
        instructionTypeId: filterPayload.instructionTypeId,
        isActive: true,
      };
      const response = await dispatch(getMilestoneV2(params)).unwrap();
      setMilestoneList(response ? response : []);
    } catch (error) {
      dispatch(
        showSnackbar({
          show: true,
          Message: `${error?.message}`,
          severity: "error",
        })
      );
    }
  };

  // function to get all tasks list
  const getAllTasks = async (payload = filterPayload) => {
    try {
      setLoader(true);
      const response = await dispatch(getAllV2DasboardTasks(payload)).unwrap();
      if (response) {
        setTotalCount(response?.recordLength || 0);
        setLoader(false);
      } else {
        setTotalCount(0);
      }
    } catch (error) {
      setLoader(false);
      setTotalCount(0);
      dispatch(
        showSnackbar({
          show: true,
          message: error?.message,
          severity: "error",
        })
      );
    } finally {
      setLoader(false);
    }
  };

  // Method to fetch all consultants.
  const getAllConsultants = async () => {
    try {
      const response = await dispatch(getConsultant()).unwrap();
      if (response?.length > 0) {
        setConsultants(response);
      } else {
        setConsultants([]);
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          show: true,
          message: error?.message,
          severity: "error",
        })
      );
    }
  };

  // Method to get all users
  const getUsers = async () => {
    try {
      setLoader(true);
      const response = await dispatch(getAllUser()).unwrap();
      if (response) {
        setLoader(false);
        setUsersList(response);
      }
    } catch (error) {
      setLoader(false);
      dispatch(
        showSnackbar({
          show: true,
          message: error?.message,
          severity: "error",
        })
      );
    }
  };

  // function to handle task pick/drop/complete actions.
  const handleTaskAction = async (task, parentTask, payload, e) => {
    e?.stopPropagation();
    try {
      setLoader(true);
      const { apiVersionId, taskType } = task;
      switch (true) {
        // old tasks
        case apiVersionId === 1 && taskType === "Instruction":
          await handleCompleteV1tasks(task, payload);
          break;
        // duplicate/custom tasks
        case taskType === "Custom" || taskType === "Instance":
          await handleCompleteDuplicateTasks(task, payload);
          break;
        // client tasks
        case taskType === "Client":
          await handleClientTask(task, payload);
          break;
        // v2 tasks
        case apiVersionId === null && taskType === "Instruction2":
          await handleCompleteV2tasks(task, parentTask, payload);
          break;

        default:
          break;
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      dispatch(
        showSnackbar({
          show: true,
          message: "",
          severity: "error",
        })
      );
    }
  };

  //function to complete v2 tasks
  const handleCompleteV2tasks = async (task, parentTask, payload) => {
    try {
      //close model immediately
      if (payload?.status === "Completed") {
        setCompleteTask(false); //close the model
      }
      setLoader(true);
      const response = await dispatch(
        completeV2Task({ id: task?.id, payload })
      ).unwrap();
      if (response) {
        //Refact---no need to fetch subTasks as we are not showing it

        //fetch subTasks when main task is picked & main tasks has subTasks
        // if (response?.isMainTaskHasSubtasks && payload?.status === "Picked") {
        //   await handleSubTaskOpen(task, null, true);
        // }

        //update realtime data
        updateDataMiddleware({
          id: task?.id,
          parentTask,
          response,
          operation: payload?.status,
        });
        if (payload?.status === "Completed") {
          await getAllTasks(); //fetch new tasks on complete
        }
        setLoader(false);
        dispatch(
          showSnackbar({
            show: true,
            message:
              payload?.status === "Completed"
                ? NOTIFICATION_MESSAGE?.COMPLETE_TASK_SUCCESS
                : payload?.status === "Dropped"
                ? NOTIFICATION_MESSAGE?.DROP_TASK_SUCCESS
                : NOTIFICATION_MESSAGE?.ASSIGN_TASK_SUCCESS,
            severity: "success",
          })
        );
      }
    } catch (error) {
      if (payload?.status === "Completed") {
        setCompleteTask(false);
      }
      setLoader(false);
      dispatch(
        showSnackbar({
          show: true,
          message: error?.message || NOTIFICATION_MESSAGE.SOMETHING_WENT_WRONG,
          severity: "error",
        })
      );
    }
  };

  //function to complete v1 tasks
  const handleCompleteV1tasks = async (task, payload) => {
    try {
      setLoader(true);
      const response = await dispatch(
        allocateOrCompleteTask({ id: task?.id, ...payload })
      ).unwrap();
      if (response) {
        //update realtime data
        updateDataMiddleware({
          id: task?.id,
          response,
          operation: payload?.status,
        });
        if (payload?.status === "Completed") {
          setCompleteTask(false);
        }
        setLoader(false);
        dispatch(
          showSnackbar({
            show: true,
            message:
              payload?.status === "Completed"
                ? NOTIFICATION_MESSAGE?.COMPLETE_TASK_SUCCESS
                : payload?.status === "Dropped"
                ? NOTIFICATION_MESSAGE?.DROP_TASK_SUCCESS
                : NOTIFICATION_MESSAGE?.ASSIGN_TASK_SUCCESS,
            severity: "success",
          })
        );
      }
    } catch (error) {
      if (payload?.status === "Completed") {
        setCompleteTask(false);
      }
      setLoader(false);
      dispatch(
        showSnackbar({
          show: true,
          message: error?.message,
          severity: "error",
        })
      );
    }
  };

  //function to complete v1 tasks custom/duplicate tasks
  const handleCompleteDuplicateTasks = async (task, payload) => {
    try {
      setLoader(true);
      const response = await dispatch(
        allocateOrCompleteIndividualTask({ id: task?.id, ...payload })
      ).unwrap();
      if (response) {
        if (payload?.status === "Completed") {
          setCompleteTask(false);
        }
        setLoader(false);
        await getAllTasks();
        dispatch(
          showSnackbar({
            show: true,
            message:
              payload?.status === "Completed"
                ? NOTIFICATION_MESSAGE?.COMPLETE_TASK_SUCCESS
                : payload?.status === "Dropped"
                ? NOTIFICATION_MESSAGE?.DROP_TASK_SUCCESS
                : NOTIFICATION_MESSAGE?.ASSIGN_TASK_SUCCESS,
            severity: "success",
          })
        );
      }
    } catch (error) {
      if (payload?.status === "Completed") {
        setCompleteTask(false);
      }
      setLoader(false);
      dispatch(
        showSnackbar({
          show: true,
          message: error?.message,
          severity: "error",
        })
      );
    }
  };

  //function to complete v1 tasks client tasks
  const handleClientTask = async (task, payload) => {
    try {
      setLoader(true);
      const response = await dispatch(
        allocateOrCompleteClientTask({ id: task?.id, ...payload })
      ).unwrap();
      if (response) {
        if (payload?.status === "Completed") {
          setCompleteTask(false);
        }
        setLoader(false);
        await getAllTasks();
        dispatch(
          showSnackbar({
            show: true,
            message:
              payload?.status === "Completed"
                ? NOTIFICATION_MESSAGE?.COMPLETE_TASK_SUCCESS
                : payload?.status === "Dropped"
                ? NOTIFICATION_MESSAGE?.DROP_TASK_SUCCESS
                : NOTIFICATION_MESSAGE?.ASSIGN_TASK_SUCCESS,
            severity: "success",
          })
        );
      }
    } catch (error) {
      if (payload?.status === "Completed") {
        setCompleteTask(false);
      }
      setLoader(false);
      dispatch(
        showSnackbar({
          show: true,
          message: error?.message,
          severity: "error",
        })
      );
    }
  };

  //Middleware function to update response in realtime
  const updateDataMiddleware = ({ id, parentTask, response, operation }) => {
    const parentTaskId = Boolean(parentTask?.id);

    if (parentTaskId) {
      dispatch(
        updateSubTask({
          subTaskid: id,
          subTaskData: response,
          parentTaskId: parentTask?.id,
          operation: operation,
        })
      );
    } else {
      dispatch(
        updateMainTask({ taskId: id, taskData: response, operation: operation })
      );
    }
  };
  //hide or show task
  function showHideTask(task) {
    const isv2Task = task?.taskType === "Instruction2";
    const isMainTask = !(task?.isSubTask === true);
    const hasSubTasks = task?.isMainTaskHasSubtasks === true ? true : false;
    const hasOutcome =
      task?.NewTaskBranching?.NewTaskBranchingOutCome?.length > 0;

    if (isv2Task && isMainTask && hasSubTasks && !hasOutcome) {
      return true;
    } else {
      return false;
    }
  }
  useEffect(() => {
    getInstructionTypeData();
    getAllTasks();
    getAllConsultants();
    userDetails?.role === USER_ROLE.SUPER_ADMIN && getUsers();
    handleGetMilestones();
  }, []);

  return (
    <>
      {/* Alert component */}
      {isCompleteTask && (
        <AlertComponent
          open={isCompleteTask}
          handleSuccess={() =>
            handleTaskAction(
              selectedCompleteTask?.task,
              selectedCompleteTask?.parentTask,
              selectedCompleteTask?.payload
            )
          }
          handleClose={() => setCompleteTask(false)}
          message="Are you sure, want to complete this task"
        />
      )}

      {loader && <Loader />}
      {/* Heading */}
      <Typography className="serif_display_regular_22 dark_grey">
        Things To Do
      </Typography>
      <Grid container marginTop={1}>
        {/* Filter */}
        <Grid container xs={12} gap={1}>
          {/* Meeting type */}
          <Grid item xs={2.5}>
            <FormControl
              fullWidth
              size="small"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "30px",
                },
              }}
            >
              <InputLabel className="normal_normal_medium_14_Manrope dark_grey">
                Meeting Type
              </InputLabel>
              <Select
                className="textField_outlined_border"
                label="Meeting Type"
                value={
                  filterPayload?.instructionTypeId?.length > 1
                    ? "null"
                    : filterPayload?.instructionTypeId
                }
                onChange={(e) => handleChangeMeetingType(e.target.value)}
              >
                <MenuItem
                  value={"null"}
                  className="normal_normal_medium_14_Manrope dark_grey"
                >
                  Both
                </MenuItem>
                {instructionTypes?.map((d) => (
                  <MenuItem
                    key={d?.id}
                    value={d?.id}
                    className="normal_normal_medium_14_Manrope dark_grey"
                  >
                    {d?.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          {/* Task type */}
          <Grid item xs={2.5}>
            <FormControl
              fullWidth
              size="small"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "30px",
                },
              }}
            >
              <InputLabel className="normal_normal_medium_14_Manrope dark_grey">
                Task Type
              </InputLabel>
              <Select
                className="textField_outlined_border"
                label="Task Type"
                value={filterPayload?.taskType}
                onChange={(e) => handleChangeTaskType(e.target.value)}
              >
                {TASK_TYPES?.map((d) => (
                  <MenuItem
                    key={d?.id}
                    value={d?.value}
                    className="normal_normal_medium_14_Manrope dark_grey"
                  >
                    {d?.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          {/* users */}
          {userDetails?.role === USER_ROLE.OFFICE_ADMIN &&
            userDetails?.permissions?.[0]?.isPermission && (
              <Grid item xs={2.5}>
                <Autocomplete
                  options={
                    userDetails?.role === USER_ROLE.SUPER_ADMIN
                      ? usersList
                      : consultants || []
                  }
                  getOptionLabel={(option) =>
                    `${option?.firstName || ""} ${option?.lastName || ""}`
                  }
                  onChange={(event, value) => handleChangeConsultant(value?.id)}
                  renderInput={(params) => (
                    <TextField
                      variant="outlined"
                      {...params}
                      className="normal_normal_medium_14_Manropee inputTextField border_color"
                      size="small"
                      label="Users"
                      placeholder="Select consultant"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: 24,
                          borderRadius: "24px",
                        },
                      }}
                    />
                  )}
                />
              </Grid>
            )}
          {userDetails?.role === USER_ROLE.SUPER_ADMIN && (
            <Grid item xs={2.5}>
              <Autocomplete
                options={usersList || []}
                getOptionLabel={(option) =>
                  `${option?.firstName || ""} ${option?.lastName || ""} 
                    (${option?.role})
                  `
                }
                onChange={(event, value) => handleChangeConsultant(value?.id)}
                renderInput={(params) => (
                  <TextField
                    variant="outlined"
                    {...params}
                    className="normal_normal_medium_14_Manropee inputTextField border_color"
                    size="small"
                    label="Users"
                    placeholder="Select consultant"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        height: 24,
                        borderRadius: "24px",
                      },
                    }}
                  />
                )}
              />
            </Grid>
          )}
          {/* ROLE */}
          {userDetails?.role === USER_ROLE.SUPER_ADMIN && (
            <Grid item xs={2.5}>
              <FormControl
                fullWidth
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "30px",
                  },
                }}
              >
                <InputLabel className="normal_normal_medium_14_Manrope dark_grey">
                  Role
                </InputLabel>
                <Select
                  className="textField_outlined_border"
                  label="Task Type"
                  value={roles?.name}
                  onChange={(e) => handleChangeRole(e?.target?.value)}
                >
                  <MenuItem value={null}>--</MenuItem>
                  {roles?.length > 0 &&
                    roles.map((d) => (
                      <MenuItem
                        key={d?.id}
                        value={d?.value}
                        className="normal_normal_medium_14_Manrope dark_grey"
                      >
                        {d?.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
          )}
        </Grid>

        {/* Pagination */}
        <Grid item xs={12} marginTop={1}>
          <PaginationComponent
            totalCount={totalCount}
            limit={filterPayload?.limit}
            page={filterPayload?.page}
            onChange={handleChangePage}
            siblingCount={0}
            boundaryCount={1}
          />
        </Grid>

        {/* Task List */}
        <Grid
          item
          xs={12}
          overflow="auto"
          className="dashboard-scrollbar"
          marginLeft={3}
          height="75vh"
        >
          {allTasks?.length > 0 ? (
            allTasks
              ?.filter((task) => !showHideTask(task)) // 👈 filter out hidden task
              ?.map((task) => {
                const isExpanded = expandedTask === task?.id;
                const subTasks = subTasksMap[task?.id] || [];

                const colourHex = milestoneList?.find(
                  (milestone) =>
                    milestone?.name?.toLowerCase() ===
                    task?.milestoneName?.toLowerCase()
                )?.colourHex;

                return (
                  <TaskCardDashboard
                    key={task?.id + task?.taskType}
                    isExpanded={isExpanded}
                    task={task}
                    subTasks={subTasks}
                    handleRedirect={handleRedirect}
                    handleRedirectSubTask={handleRedirectSubTask}
                    handleSubTaskOpen={handleSubTaskOpen}
                    handleCompleteTask={handleCompleteTask}
                    handleTaskAction={handleTaskAction}
                    checkDate={checkDate}
                    getInitialsFromFullName={getInitialsFromFullName}
                    colourHex={colourHex}
                    getAllTasks={getAllTasks}
                    subTasksMap={subTasksMap}
                  />
                );
              })
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Typography className="normal_normal_18_Manropee">
                Tasks Not Found!
              </Typography>
            </div>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default NewThingsToDo;
